document.addEventListener('DOMContentLoaded', function () {
  var animatedGroups = document.querySelectorAll('.banner-duo--animate');
  if (!animatedGroups.length || !('IntersectionObserver' in window)) {
    document.querySelectorAll('.banner-duo__item').forEach(function (item) {
      item.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  animatedGroups.forEach(function (group) {
    var items = group.querySelectorAll('.banner-duo__item');
    items.forEach(function (item, index) {
      item.style.transitionDelay = (index * 120) + 'ms';
      observer.observe(item);
    });
  });
});